import z from 'zod';

const zodPreprocessorToNumber = z.preprocess((value) => {
  if (typeof value === 'string' || typeof value === 'number') {
    const number = Number(value);
    return Number.isNaN(number) ? undefined : number;
  }
  return undefined;
}, z.number().int().positive());

export const CartGetHasCreatorProductOnCartReqQuerySchema = z.object({
  user_id: zodPreprocessorToNumber,
  store_id: zodPreprocessorToNumber,
});
